// export const FETCH_PRODUCTS = 'FETCH_PRODUCTS';

export const FETCH_PRODUCTS_PENDING = 'FETCH_PRODUCTS_PENDING';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILED = 'FETCH_PRODUCTS_FAILED';

export const FILTER_PRODUCTS_BY_ALL = 'FILTER_PRODUCTS_BY_ALL';
export const SORT_PRODUCTS = 'SORT_PRODUCTS';
export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';

export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const GET_LOCAL_CART = "GET_LOCAL_CART";
export const UPDATE_PRODUCT_COUNT = "UPDATE_PRODUCT_COUNT";

export const USER_LOGIN_SUBMIT = "USER_LOGIN_SUBMIT";
export const USER_EMAIL_CHANGE = "USER_EMAIL_CHANGE";
export const USER_PASSWORD_CHANGE = "USER_PASSWORD_CHANGE";
export const SET_USER_AUTH = "SET_USER_AUTH";
export const SET_USER_AUTH_OUT = "SET_USER_AUTH_OUT";
export const LOG_OUT_USER = "LOG_OUT_USER";

export const ERROR_MESSAGE = "ERROR_MESSAGE";
export const CLOSE_ALERT = "CLOSE_ALERT";
export const READ_PROFILE = "READ_PROFILE";

export const SET_AT_ADMIN = "SET_AT_ADMIN";



